import { Dialog, Button, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { DefaultDialogProps } from './types';
import useController from './useController';

const DefaultDialog = ({
  dialogActionsProps,
  dialogButtonProps,
  dialogContentProps,
  dialogContentTextProps,
  dialogProps,
  dialogTitleProps,
  label = 'OK',
}: DefaultDialogProps) => {
  const { dialogMessage, dialogTitle, isDialogOpen, onCloseDialog } = useController();

  return (
    <Dialog open={isDialogOpen} {...dialogProps}>
      <DialogTitle {...dialogTitleProps}>{dialogTitle}</DialogTitle>
      <DialogContent {...dialogContentProps}>
        <DialogContentText {...dialogContentTextProps}>{dialogMessage}</DialogContentText>
      </DialogContent>
      <DialogActions {...dialogActionsProps}>
        <Button onClick={onCloseDialog} {...dialogButtonProps}>
          {label}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultDialog;
